



















import { Vue, Component, Prop, Model, Watch } from 'vue-property-decorator';

import ScheduleDayField, { defineEmptyScheduleDay } from './ScheduleDayField.vue';

import { WEEKDAYS } from '../../consts';

import { getWeekday, getDaysDifference, DAYS_IN_WEEK } from '@/utils/date';
import { getWeekdayShortName } from '@/utils/date/consts';

import { ScheduleDay } from './types';
import { SelectItem, SelectValue } from '@/components/select/types';
import { Weekday, ISOCalendarDate, } from '@/utils/date/types';

@Component({
    components: {
        ScheduleDayField
    },
})
export default class ScheduleDayList extends Vue {
    @Model('update:days') days!: ScheduleDay[]
    @Prop({ required: true }) from!: ISOCalendarDate
    @Prop({ required: true }) to!: ISOCalendarDate
    @Prop({ default: () => [] }) clinics!: SelectItem[]
    @Prop({ default: null }) mainClinic!: SelectValue

    schedule = WEEKDAYS.map(defineEmptyScheduleDay);

    get periodLength() {
        if (this.from && this.to) {
            const periodDifference = getDaysDifference(this.from, this.to);

            if (periodDifference < 0) {
                return 0;
            }

            return Math.min(periodDifference + 1, DAYS_IN_WEEK);
        }

        return 0;
    }

    get visibleWeekdays() {
        const visibleWeekdays = new Set<Weekday>();

        let weekday = getWeekday(this.from);

        for (let count = 0; count < this.periodLength; count += 1) {
            visibleWeekdays.add(weekday);
            
            weekday = weekday + 1;

            if (weekday > Weekday.Sunday) {
                weekday = Weekday.Monday;
            }
        }

        return visibleWeekdays;
    }

    @Watch('days', { deep: true })
    syncSchedule(schedule: ScheduleDay[]) {
        this.schedule = schedule;
    }

    @Watch('visibleWeekdays')
    updateDaysVisibility(visibleWeekdays: Set<Weekday>) {
        this.schedule = this.schedule.map(day => {
            const hidden = !visibleWeekdays.has(day.weekday);

            return {
                ...day,
                hidden,
            }
        })
    }

    @Watch('mainClinic')
    setClinics(clinic: SelectValue) {
        if (!clinic) {
            return;
        }

        const days = this.schedule.map(day => ({
            ...day,
            clinic,
        }))

        this.saveSchedule(days);
    }

    getWeekname(weekday: Weekday) {
        return getWeekdayShortName(weekday)
    }

    updateDay(newDay: ScheduleDay, oldDay: ScheduleDay) {
        const days = this.schedule.map(day => day === oldDay ? newDay : day);

        this.saveSchedule(days);
    }

    saveSchedule(schedule: ScheduleDay[]) {
        this.schedule = schedule;
        
        this.$emit('update:days', schedule);
    }
}
